import { useContext } from 'react';

import { ThemeModeContext } from './ThemeModeContext';
import type { ThemeModeContextValue } from './ThemeModeContext';

/** Read the active color mode + togglers. Throws outside the app `ThemeProvider`. */
export function useThemeMode(): ThemeModeContextValue {
  const context = useContext(ThemeModeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within the application ThemeProvider');
  }
  return context;
}
